import React from "react";
import { Link } from "react-router-dom";
import { useCollections } from "api/use-intercom";
import LoadingSpinner from "components/loading-spinner";
import SearchDropdown from "components/search-dropdown";
// import { useTranslation } from "react-i18next";
import "./article.css";
import ScrollToTop from "components/scroll-to-top";
import LegoMan from "assets/legoman.png";

export default function HelpCenterHome() {
  const { data: collections, isLoading, error } = useCollections();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-white">
        <div className="container mx-auto px-4 py-8">
          <ScrollToTop />
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-white">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-red-600 mb-4">
              Error loading help center
            </h1>
            <p className="text-gray-600">{error.message}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!collections) {
    return (
      <div className="min-h-screen bg-white">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              Sorry, we couldn't find the help center.
            </h1>
            <p className="text-gray-600">
              The help center you're looking for might have been moved or
              deleted.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-300/25 flex justify-center">
      <ScrollToTop />
      <div className="md:px-8 my-0 lg:my-12 py-8 md:py-0 relative bg-white rounded-xl w-full lg:w-[800px]">
        {/* <div className="md:mt-10 px-[1rem] flex items-center text-sm text-tertiary flex-wrap gap-y-2 md:gap-y-0">
          <div className="text-black whitespace-nowrap">Help Center</div>
        </div> */}
        <div className="px-4 py-8 flex flex-col">
          <div className="flex flex-col md:flex-row gap-12 border-b border-gray-300 md:-mx-4 px-4 items-end w-full justify-between">
            <div className="flex flex-col pb-8 grow">
              <h1 className="text-[2rem] font-bold">Help Center</h1>
              <div className="text-tertiary text-[1.25rem] mb-6">
                Get help with your LEGO Brick Take Back
              </div>
              <SearchDropdown className="w-full" />
            </div>
            <img src={LegoMan} alt="" className="w-32 h-32 object-contain" />
          </div>
          <div className="flex flex-col">
            {collections.data?.map((collection, index, array) => (
              <Link
                to={`/en-US/help/collections/${collection.id}`}
                key={collection.id}
                className={`hover:bg-blue-300/25 min-h-20 flex gap-8 items-center md:-mx-4 px-4 ${
                  index !== array.length - 1 ? " border-gray-300 " : ""
                }`}
              >
                <div className="w-16 h-16 bg-red rounded-lg flex justify-center items-center shrink-0">
                  <span className="material-symbols-outlined text-white">
                    folder
                  </span>
                </div>
                <div className="flex flex-col gap-1 w-full my-4 py-2">
                  <div className="">{collection.name}</div>
                  <div className="text-tertiary">{collection.description}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
